import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    cajas: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    cajasSelect: [],
    cajasSelectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.cajas = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },

    'INICIALIZAR_CAJAS' (state) {
        state.cajas = [];
    },
    'SET_CAJAS' (state, cajas) {
        state.cajas = cajas;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_CAJAS_SELECT'(state) {
        state.cajasSelect = [];
        state.cajasSelectList = [];
    },
    'SET_CAJAS_SELECT'(state, params) {
        state.cajasSelect = params.cajasSelect;
        state.cajasSelectList = params.cajasSelectList;
    },
};

const getters = {
    getField,

    cajasSelect (state) {
        return state.cajasSelect;
    },
    cajasSelectList (state) {
        return state.cajasSelectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCajas ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJAS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            apiAxios.get('cajas/cajas' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CAJAS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
        }, error => {
            reject(error);
        })
    },

    getCajasSelect: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJAS_SELECT');

            apiAxios.get('cajas/list')
                .then(res => {
                    let list = [];
                    for(let key in res.data) {
                        const caja = res.data[key]
                        list.push(caja.nombre.trim())
                    }
                    let params = {
                        cajasSelect: res.data,
                        cajasSelectList: list
                    }
                    
                    commit('SET_CAJAS_SELECT', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },

    getCajasAbrirSelect: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJAS_SELECT');

            apiAxios.get('cajas/cerradas')
                .then(res => {
                    let list = [];
                    for(let key in res.data) {
                        const caja = res.data[key]
                        list.push(caja.nombre.trim())
                    }
                    let params = {
                        cajasSelect: res.data,
                        cajasSelectList: list
                    }
                    
                    commit('SET_CAJAS_SELECT', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}